import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  FaUserTie,
  FaUsers,
  FaMoneyCheckAlt,
  FaUserClock,
  FaBuilding,
  FaAward,
} from "react-icons/fa";
const serviceData = [
  {
    title: "Expertise",
    icon: <FaUserTie />,
    description:
      "TIG offers end-to-end hiring solutions backed by professional recruitment infrastructure and deep industry acumen.",
  },
  {
    title: "Staffing Solutions",
    icon: <FaUsers />,
    description:
      "Our talent pool includes IT experts, wealth advisors, retail staff, engineers, and senior executives.",
  },
  {
    title: "Payroll Management",
    icon: <FaMoneyCheckAlt />,
    description:
      "We ensure timely staff payment—regardless of client-side reimbursement—offering unmatched financial reliability.",
  },
  {
    title: "Hiring Support",
    icon: <FaUserClock />,
    description:
      "With a vast CV database, TIG quickly meets urgent client needs with resourceful, pre-vetted candidates.",
  },
  {
    title: "Trusted by Institutions",
    icon: <FaBuilding />,
    description:
      "We serve top banks and institutions across Oman and Asia—delivering consistent, high-quality manpower solutions.",
  },
  {
    title: "Proven Track Record",
    icon: <FaAward />,
    description:
      "With 24+ years of experience and results, TIG remains a trusted leader in staffing and recruitment services.",
  },
];

const StaffingSolutions = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <section className="container py-2 text-center" data-aos="fade-up">
      <h6 className="fw-bold" style={{ color: "#061E42" }}>
        TIG Staffing & Recruitment Excellence
      </h6>
      <h2 className="fw-bold mb-4">
        Custom workforce and payroll solutions
        <br />
        <span className="text-dark">tailored to your business success.</span>
      </h2>

      <div className="row">
        {serviceData.map((item, index) => (
          <div
            className="col-md-4 mb-4"
            key={index}
            
          >
            <div className="card service-card h-100 px-3 py-4 text-center">
              <div className="service-icon-wrapper mb-3">
                <div className="service-icon">{item.icon}</div>
              </div>
              <h5 className="fw-bold">{item.title}</h5>
              <p className="text-muted">{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StaffingSolutions;
